<template>
	<div class="banner4">
		<div class="banner5containtText">
			{{$t('banner5.title')}}
		</div>
		<img :class="'topbg ' + topbgANi" src="../../assets/banner6/aboutbg.png" >
		<!-- curpage == 5 -->
		<slider v-model="sliderIndex" :touch="true" :interval="3500" :speed="1000" :autoplay="true" :control-btn="true" animation="normal"
			class="bannerSwiper" style="height: 60vh; width: 90vw;">
			<!-- Market Insights -->
			<slider-item class="slideritem">
				<div class="texchnologyItem">
					<div class="texchnologyItemItm">
						<img :class="curpage == 5 ? 'imgbg imgbgAni1' : 'imgbg'" src="../../assets/banner6/aboutbg.png" >
						<img :class="curpage == 5 ? 'imgicon imgiconAni1': 'imgicon'" src="../../assets/banner6/dboml.png" >
					</div>
					<p class="title">
						{{$t('banner5.slide1.title')}}
					</p>
					<p class="desc">
						{{$t('banner5.slide1.desc')}}
					</p>
				</div>
				<div class="texchnologyItem">
					<div class="texchnologyItemItm">
						<img :class="curpage == 5 ? 'imgbg imgbgAni2' : 'imgbg'" src="../../assets/banner6/aboutbg.png" >
						<img :class="curpage == 5 ? 'imgicon imgiconAni2': 'imgicon'" src="../../assets/banner6/dgbip.png" >
					</div>
					<p class="title">
						{{$t('banner5.slide2.title')}}
					</p>
					<p class="desc">
						{{$t('banner5.slide2.desc')}}
					</p>
				</div>
				<div class="texchnologyItem">
					<div class="texchnologyItemItm">
						<!-- <img :class="curpage == 5 ? 'imgbg imgBgAni' : 'imgbg'" src="../../assets/banner6/aboutbg.png" > -->
						<img :class="curpage == 5 ? 'imgbg imgbgAni3' : 'imgbg'" src="../../assets/banner6/aboutbg.png" >
						<img style="top: 0.725rem; left: 0.1rem;" :class="curpage == 5 ? 'imgicon imgiconAni3': 'imgicon'" src="../../assets/banner6/ams.png" >
					</div>
					<p class="title">
						{{$t('banner5.slide3.title')}}
					</p>
					<p class="desc">
						{{$t('banner5.slide3.desc')}}
					</p>
				</div>
			</slider-item>
			<!-- Funding Support -->
			<slider-item class="slideritem">
				<div class="texchnologyItem">
					<div class="texchnologyItemItm">
						<!-- <img :class="curpage == 5 ? 'imgbg imgBgAni' : 'imgbg'" src="../../assets/banner6/aboutbg.png" > -->
						<img :class="curpage == 5 ? 'imgbg imgbgAni1' : 'imgbg'" src="../../assets/banner6/aboutbg.png" >
						<img :class="curpage == 5 ? 'imgicon imgiconAni1': 'imgicon'" src="../../assets/banner6/smart.png" >
					</div>
					<p class="title">
						{{$t('banner5.slide4.title')}}
					</p>
					<p class="desc">
						{{$t('banner5.slide4.desc')}}
					</p>
				</div>
				<div class="texchnologyItem">
					<div class="texchnologyItemItm">
						<!-- <img :class="curpage == 5 ? 'imgbg imgBgAni' : 'imgbg'" src="../../assets/banner6/aboutbg.png" > -->
						<img :class="curpage == 5 ? 'imgbg imgbgAni2' : 'imgbg'" src="../../assets/banner6/aboutbg.png" >
						<img  :class="curpage == 5 ? 'imgicon imgiconAni2': 'imgicon'" src="../../assets/banner6/mddpaa.png" >
					</div>
					<p class="title">
						{{$t('banner5.slide5.title')}}
					</p>
					<p class="desc">
						{{$t('banner5.slide5.desc')}}
					</p>
				</div>
				<div class="texchnologyItem">
					<div class="texchnologyItemItm">
						<!-- <img :class="curpage == 5 ? 'imgbg imgBgAni' : 'imgbg'" src="../../assets/banner6/aboutbg.png" > -->
						<img :class="curpage == 5 ? 'imgbg imgbgAni3' : 'imgbg'" src="../../assets/banner6/aboutbg.png" >
						<img :class="curpage == 5 ? 'imgicon imgiconAni3': 'imgicon'" src="../../assets/banner6/rtdt.png" >
					</div>
					<p class="title">
						{{$t('banner5.slide6.title')}}
					</p>
					<p class="desc">
						{{$t('banner5.slide6.desc')}}
					</p>
				</div>
			</slider-item>
		</slider>
	</div>
</template>

<script>
	import {
		Slider,
		SliderItem
	} from 'vue-easy-slider'
	export default {
		props: ['curpage', 'aniDownUp'],
		components: {
			Slider,
			SliderItem
		},
		data () {
			return {
				sliderIndex: 0,
				topbgANi: '' // 如果是从上一页下来，则做该动画topbAni
			}
		},
		watch: {
			'curpage': {
				handler(newvalue, oldvalue) {
					this.sliderIndex = 0
					this.topbgANi = ''
					if (newvalue === 5) {
						this.sliderIndex = 0
						if (this.aniDownUp == 'down') {
							this.topbgANi = 'topbAni'
						} else {
							this.topbgANi = ''
						}
					}
				}
			},
			'aniDownUp': {
				handler (newvalue, oldvalue) {
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	/deep/ .slider-btn {
		display: none !important;
	}

	/deep/ .slider-indicator-icon {
		background-color: rgba(0, 0, 0, 0) !important;
		margin: 1px 0.1rem !important;
		border: 1px solid #000 !important;
		width: 10px !important;
		height: 10px !important;
	}
	
	/deep/ .slider-indicator-active {
		background-color: #000 !important;
	}
	.banner4 {
		height: 100vh;
		background-repeat:no-repeat;
		background-size: 100%;
		background-size: cover;
		text-align: left;
		box-sizing: border-box;
		font-family: 'PilatTest-Bold';
		padding: 2.575rem 1.25rem;
		padding-left: 1.5625rem;
		position: relative;
		box-sizing: border-box;
		.banner5containtText {
			position: absolute;
			font-size: 1.475rem;
			top: 20%;
			transform: translateY(-50%);
			-webkit-text-stroke: 1px #000;
			-webkit-text-fill-color : transparent;
			font-family: 'PilatTest-Bold';
		}
		.topbg {
			width: 3.125rem;
			top: 0;
			position: absolute;
			opacity: 0;
			
		}
		.topbAni {
			animation: topbgANi 0.5s;
			animation-delay: 0.5s;
			// animation-fill-mode: ;
			animation-fill-mode: forwards;
		}
		.bannerSwiper {
			display: flex;
			box-sizing: border-box;
			overflow: hidden;
			padding-left: 1.5625rem;
			position: absolute;
			bottom: 0.625rem;
			.slideritem {
				display: flex;
				// width: 100%;
				box-sizing: border-box;
				// background-color: green;
				box-sizing: border-box;
				display: flex;
				// padding-right: 2.27rem !important;
				justify-content: space-between;
				// padding-left: 0.1rem;
				.texchnologyItem {
					box-sizing: border-box;
					flex: 1;
					height: 100%;
					.texchnologyItemItm {
						text-align: center;
						position: relative;
						height: auto;
						
						img {
							position: absolute;
						}
						.imgbg {
							position: absolute;
							width: 3.125rem;
							left: 0;
							margin: 0 auto;
							top: 0px;
							opacity: 0;
						}
						.imgBgAni {
							opacity: 0;
							animation-fill-mode: forwards;
						}
						.imgicon {
							position: absolute;
							width: 2rem;
							left: -0.1rem;
							opacity: 0;
							top: 0.675rem;
						}
						.imgiconAni {
							animation: imgicon_ani 1s;
							animation-fill-mode: forwards;
							animation-delay: 1.2s;
						}
						.imgbgAni1 {
							animation: imgicon_ani 0.5s;
							animation-fill-mode: forwards;
							animation-delay: 1s;
						}
						.imgbgAni2 {
							animation: imgicon_ani 0.5s;
							animation-fill-mode: forwards;
							animation-delay: 1.2s;
						}
						.imgbgAni3 {
							animation: imgicon_ani 0.5s;
							animation-fill-mode: forwards;
							animation-delay: 2.2s;
						}
						.imgiconAni1 {
							animation: imgicon_ani 0.5s;
							animation-fill-mode: forwards;
							animation-delay: 1.2s;
						}
						.imgiconAni2 {
							animation: imgicon_ani 0.5s;
							animation-fill-mode: forwards;
							animation-delay: 1.7s;
						}
						.imgiconAni3 {
							animation: imgicon_ani 0.5s;
							animation-fill-mode: forwards;
							animation-delay: 2.3s;
						}
					}
					.title {
						width: 30%;
						position: absolute;
						top: 40%;
						color: #EE5A22;
						font-size: 0.56em;
						line-height: 0.875rem;
						box-sizing: border-box;
						font-family: 'PilatTest-Bold';
					}
					.desc {
						color: #000;
						font-size: 0.40rem;
						padding: 0.225rem;
						padding-left: 0;
						position: absolute;
						top: 60%;
						width: 30%;
					}
				}
			}
		}
	}
	@keyframes imgbg_ani {
		0% {
			width: 3.125rem;
			transform: rotateZ(0deg);
		}
		50% {
			width: 3.225rem;
			transform: rotateZ(360deg);
		}
		100% {
			width: 3.125rem;
			transform: rotateZ(360deg);
		}
	}
	@keyframes topbgANi {
		0% {
			top: 0;
			opacity: 0;
		}
		90% {
			top: 35%;
			opacity: 1;
		}
		100% {
			top: 35%;
			opacity: 0;
		}
	}
	@keyframes imgicon_ani {
		0% {
			opacity: 0;
		}
		100% {
			opacity: 1;
		}
	}
</style>
